import React, { useContext } from "react";

import {
	ResultsContext,
	ResultsTournamentContext,
} from "@state/context/results";
import range from "lodash/range";

import { calculateTableBodyColspan, tbodyColspanMax } from "./utils";

export default function EmptyHeaderSpacesWrapper() {
	const result = useContext(ResultsContext);
	const tournament = useContext(ResultsTournamentContext);
	const tbodyColspan = calculateTableBodyColspan(result.sport.abrv);

	if (tbodyColspan >= tbodyColspanMax) {
		return null;
	}

	return (
		<>
			{range(tbodyColspanMax - tbodyColspan).map((item, idx) => {
				return (
					<th
						key={`${tournament.id}-${idx}`}
						className="table--results__subheader__data is-empty"
					>
						&nbsp;
					</th>
				);
			})}
		</>
	);
}
